import React from 'react';
import { DashboardJson } from '../modules/models';
import { noDashboardPermissions, UserDashboardPermissions } from '../utils';

export type Registry = {
  [k: string]: any;
};

export type DashboardContextType = {
  TemplateRegistry: ReadonlyArray<DashboardJson>;
  OrionRegistry: ReadonlyArray<DashboardJson>;
  ComponentRegistry: Readonly<Registry>;
  DatasourceRegistry: Readonly<Registry>;
  UserDashboardPermissions: UserDashboardPermissions;
  isOpenSourceCode: boolean;
  setIsOpenSourceCode: React.Dispatch<React.SetStateAction<boolean>>;
  updateTemplate: (template: DashboardJson) => void;
  addTemplate: (template: DashboardJson) => void;
  removeTemplate: (template: DashboardJson) => void;
};

export const DashboardContext = React.createContext<DashboardContextType>({
  TemplateRegistry: [] as ReadonlyArray<Registry>,
  OrionRegistry: [] as ReadonlyArray<Registry>,
  ComponentRegistry: {},
  DatasourceRegistry: {},
  UserDashboardPermissions: noDashboardPermissions,
  isOpenSourceCode: false,
  setIsOpenSourceCode: () => {},
  updateTemplate: template => {},
  addTemplate: template => {},
  removeTemplate: template => {},
});
